import { render, staticRenderFns } from "./dialogConformSetHomePage.vue?vue&type=template&id=63bce497&"
import script from "./dialogConformSetHomePage.vue?vue&type=script&lang=js&"
export * from "./dialogConformSetHomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports